import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { StatusCodes } from "@obg/ngx.global";
import { Observable } from "rxjs";

import { MultiSessionLimitConfigService } from "./multi-session-limit.config";
import { MultiSessionLimit, MultiSessionLimits } from "./multi-session-limit.model";

@Injectable({
	providedIn: "root",
})
export class MultiSessionLimitService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: MultiSessionLimitConfigService
	) {}

	get(): Observable<MultiSessionLimits> {
		return this.httpClient.get<MultiSessionLimits>({
			url: this.config.getMultiSessionLimitEndpoint(),
			suppressErrorLogging: [StatusCodes.Unauthorized],
		});
	}

	update(params: MultiSessionLimit): Observable<MultiSessionLimits> {
		return this.httpClient.put<MultiSessionLimits>({
			url: this.config.getMultiSessionLimitEndpoint(),
			data: params,
		});
	}

	remove(): Observable<object> {
		return this.httpClient.delete({ url: this.config.getMultiSessionLimitEndpoint() });
	}
}
